import * as React from 'react';
import axios from 'axios';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

import { useContext } from 'react'; 
import { UserContext } from '../context/UserContext.js';

import Grid from '@mui/material/Grid'
import CircularProgress from '@mui/material/CircularProgress';
import { Typography } from '@mui/material';
// import Input from '@mui/material/Input'
import MessageSnackBar from './MessageSnackBar';

const Input = styled('input')({
  display: 'none',
});

export default function UploadButtons(props) {
  const userData = useContext(UserContext);



  const [selectedFile, setSelectedFile ] = React.useState();
  const [selectedFileName, setSelectedFileName ] = React.useState(true);
  const [viewSelectFileButton, setViewSelectFileButton ] = React.useState(true);
  const [viewLoadingSpinner, setviewLoadingSpinner ] = React.useState(false);

  //SECTION Message Bar Controls
  const [ messageBarMessage, setMessageBarMessage ] = React.useState('');
  const [ messageBarOpen, setMessageBarOpen ] = React.useState(false);
  const [ messageSeverity, setMessageSeverity ] = React.useState('success')
  const handleMessageBarClosing = () => {
    setMessageBarOpen(false);
  };
  //!SECTION

  const handleCapture = (event) => {

    setSelectedFile(event.target.files[0])
    setSelectedFileName(event.target.files[0].name)
    setViewSelectFileButton(false);


  }
  //SECTION Axios Upload a Demand File Post
  const handleUploadFile = () => {
    const userid = userData.email
    setviewLoadingSpinner(true);

    const formData = new FormData();
    formData.append('file', selectedFile);

    var postConfig = {
      method: 'post',
      url: `/platformsuperdirtyfile/${userid}/${props.accountCode}`,
      data : formData
    };
    axios(postConfig)
    .then(function (response) {

      setviewLoadingSpinner(false);
      // props.handleUploadData(message, response);
      setViewSelectFileButton(true); 
      if (response.data.code){
        // console.log(Object.values(response.data)[1])
        alert(Object.values(response.data)[1])
        return
      }
      props.handleUploadData(response);
    })
    .catch(function (error) {
      setviewLoadingSpinner(false);
      //!Message bar
      setMessageBarMessage(`Oh no! Something went wrong. Please try again or email info@edonconnect.tech for help. ${error.message}`);
      setMessageBarOpen(true);
      setMessageSeverity("error") // error: red, warning: orange, information: blue, success: green
    });
  }
  //!SECTION


  return (

    <Grid container marginTop={5} sx={{justifyContent:'center', alignItems:'center', alignContent:'center', p:1, border:1, borderStyle: 'dotted', borderRadius: '5px'  }}>
      <MessageSnackBar messageBarMessage={messageBarMessage} messageBarOpen={messageBarOpen} handleMessageBarClosing={handleMessageBarClosing} messageSeverity={messageSeverity} />
    {viewSelectFileButton &&
        <Grid container  sx={{justifyContent:'center', border:0, p:5, borderStyle: 'dotted', borderRadius: '5px'  }} >
          <label htmlFor="contained-button-file">
            <Button variant="contained" component="label">
            <Input accept=".csv" onChange={handleCapture} id="contained-button-file" hidden type="file" />
              Select Your File
            </Button>
          </label>
        </Grid>
        }

      {!viewSelectFileButton &&
      <Grid container sx={{justifyContent:'center', border:0, p:0, borderStyle: 'dotted', borderRadius: '5px'  }}>
        <Button onClick={handleUploadFile} variant="contained" component="label">
          Upload
          {viewLoadingSpinner &&
          <CircularProgress sx={{margin:1}} color="inherit" size ={20}/>
            }
        </Button>
        <Grid container sx={{justifyContent:'center', border:0, p:0, borderStyle: 'dotted', borderRadius: '5px'  }}>
      <Typography>
            {selectedFileName}
      </Typography>
      </Grid>
      </Grid>
      }

    </Grid>
  );
}